// extracted by mini-css-extract-plugin
module.exports = {"cv":"Cv_cv__3BbT1","items":"Cv_items__EhNUD"};